<template>
  <div>
    <div class="selection-details">
      <h3>
        Select Item {{ level + 1 }} ( {{ comboSelectedModifiers.length }} of
        {{ ComboModifierGroups.length }} selected)
      </h3>
    </div>
    <div class="combo-modifier-list row" v-if="!isShowSubmodifier">
      <div
        class="col-4 combo-item"
        v-for="modifier in ComboModifierGroups[level].Modifiers"
        :key="modifier.ID"
        @click="showSubmodifier(modifier)"
      >
        <img :src="modifierPic(modifier)" />
        <span>{{ modifier.Name }}</span>
        <br />
        <span>+ {{ modifier.Price | formatMoney }}</span>
      </div>
    </div>
    <div class="btn-combo-next-container justify-content-between" v-if="!isShowSubmodifier">
      <button type="button" class="btn btn-lg btn-cancel" @click="goBack()">{{ $t("message.back") }}</button>
      <button
        type="button"
        :style="desktopStyles.btn"
        class="btn btn-lg btn-primary w-75 shadow"
        @click="goNext()"
      >{{ $t("message.next") }}</button>
    </div>
    <div v-if="isShowSubmodifier" class="combo-modifier-list row">
      <div class="header col-12">
        <div class="col-4 combo-item">
          <img :src="modifierPic(selectedModifier)" />
          <span>{{ selectedModifier.Name }}</span>
        </div>
      </div>
      <div class="submodifiers col-12 mt-4">
        <Modifiers
          :product="linkedProduct"
          :modifiers="modifiers"
          :is-submodifier="false"
          :modifier-groups-states="selectedModifierModifierGroupsStates"
          :initial-modifiers="selectedModifier.selectedSubmodifiers"
        />
      </div>
    </div>
    <div class="btn-combo-next-container justify-content-between sticky" v-if="isShowSubmodifier">
      <button
        type="button"
        class="btn btn-lg btn-cancel"
        @click="backToList()"
      >{{ $t("message.back") }}</button>
      <button
        type="button"
        :style="desktopStyles.btn"
        class="btn btn-lg btn-primary w-75 shadow"
        @click="confirm(selectedModifier)"
      >{{ $t("message.confirm") }} {{ selectedModifier.Name }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Modifiers from "./Modifiers";
import shared from "../../../sharedscripts/shop/products/ProductCombo.js";
export default {
  name: "ProductCombo",
  components: { Modifiers },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    ComboModifierGroups: {
      type: Array,
      default: () => []
    },
    modifiers: {
      type: Object,
      default: () => {}
    },
    comboSelectedModifiers: {
      type: Array,
      default: () => []
    }
  },
  watch: {},
  data() {
    return {
      level: 0,
      isShowSubmodifier: false,
      selectedModifier: null,
      selectedModifierModifierGroupsStates: []
    };
  },
  mounted() {},
  computed: {
    ...shared.computed,
    ...mapGetters(["viewConfig", "desktopStyles", "getProductById"]),
    linkedProduct() {
      return this.getProductById(this.selectedModifier.LinkedProductID);
    }
  },
  methods: {
    ...shared.methods,
    modifierPic(modifier) {
      if (modifier.PhotoURL) return modifier.PhotoURL;
      else
        return "https://www.shareicon.net/data/128x128/2015/10/01/649583_fork_512x512.png";
    },
    showSubmodifier(modifier) {
      this.selectedModifierModifierGroupsStates.splice(
        0,
        this.selectedModifierModifierGroupsStates.length
      );
      var find = this.comboSelectedModifiers.find(
        p => p.modifier.ID == modifier.ID && p.level == this.level
      );
      if (find) this.selectedModifier = find.modifier;
      else this.selectedModifier = modifier;
      if (this.linkedProduct) {
        if (
          !this.linkedProduct.Modifiers ||
          this.linkedProduct.Modifiers.length == 0
        ) {
          this.confirm(this.selectedModifier);
          return;
        }
      } else {
        this.confirm(this.selectedModifier);
        return;
      }
      this.isShowSubmodifier = true;
    },
    confirm(modifier) {
      var copyOfModifier = JSON.parse(JSON.stringify(modifier));
      copyOfModifier.quantity = 1;

      Object.defineProperty(copyOfModifier, "quantity", {
        enumerable: true,
        writable: true,
        value: 1
      });
      Object.defineProperty(copyOfModifier, "IsSelected", {
        enumerable: true,
        writable: true,
        value: true
      });
      if (
        this.selectedModifierModifierGroupsStates.filter(p => p.quantity > 0)
          .length > 0
      ) {
        var result = [];
        this.selectedModifierModifierGroupsStates
          .filter(p => p.quantity > 0)
          .forEach(element => {
            result.push({
              ...this.modifiers[element.GroupId].Modifiers.find(
                p => p.ID == element.MID
              )
            });
          });

        this.$set(copyOfModifier, "selectedSubmodifiers", result);
      }
      var find = this.comboSelectedModifiers.find(p => p.level == this.level);
      if (find) find.modifier = copyOfModifier;
      else
        this.comboSelectedModifiers.push({
          level: this.level,
          modifier: copyOfModifier
        });

      this.selectedModifier = null;
      this.isShowSubmodifier = false;
      this.goNext();
      this.$emit("update", this.comboSelectedModifiers);
    },
    goNext() {
      if (this.level < this.ComboModifierGroups.length - 1) this.level++;
      else if (
        this.comboSelectedModifiers.length == this.ComboModifierGroups.length
      )
        this.$emit("cancel");
    },
    goBack() {
      if (this.level > 0) this.level--;
      else this.$emit("cancel");
    },
    backToList() {
      this.selectedModifier = null;
      this.isShowSubmodifier = false;
    }
  }
};
</script>
